import type { Schema } from "@productlane/zero"
import { mutators } from "@productlane/zero/mutators"

import type { GroupWithArticles } from "./types"
import type { Zero } from "@rocicorp/zero"
import { generateId } from "@/lib/id"
import { mutateOk } from "@/lib/zero"

// Shared by the rename dialog and the inline (double-click) rename in the nav.
export async function renameGroup({
	zero,
	workspaceId,
	defaultLanguage,
	group,
	language,
	name,
}: {
	zero: Zero<Schema>
	workspaceId: string
	defaultLanguage: string
	group: Pick<GroupWithArticles, "id" | "translations">
	language: string
	name: string
}) {
	const existingId = group.translations?.find(
		(t) => t.language === language,
	)?.id

	await mutateOk(
		zero.mutate(
			mutators.helpCenterGroupTranslations.upsert({
				id: existingId ?? generateId(),
				workspaceId,
				language,
				helpCenterGroupId: group.id,
				title: name,
			}),
		),
	)

	if (language === defaultLanguage) {
		await mutateOk(
			zero.mutate(mutators.helpCenterGroups.update({ id: group.id, name })),
		)
	}
}
